<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="待确定" name="0"></el-tab-pane>
            <el-tab-pane label="待完成" name="3"></el-tab-pane>
            <el-tab-pane label="已完成" name="5"></el-tab-pane>
        </el-tabs>
        <div class="list-content">
            <div class="order-item" v-for="(item,index) in list" :key="index">
                <div class="order-item-head">
                    <div>{{item.type === 3 ? '精品路线' : '接机服务'}}</div>
                    <div class="ml-20">发布于：{{item.reception_time}}</div>
                    <div class="ml-a color-red">{{stateName}}</div>
                </div>
                <div class="order-body">
                    <img class="order-body-img" :src="`/api/v1/file/${item.driver_portrait}`" alt="">
                    <div class="order-content">
                        <el-form label-width="100px" label-position="right">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item style="margin-bottom: 0;" label="订单编号：">{{item.out_trado_no}}</el-form-item>
                                    <el-form-item v-if="item.flight" style="margin-bottom: 0;" label="航班号：">{{item.flight}}</el-form-item>
                                    <el-form-item style="margin-bottom: 0;" label="到达终点：">{{item.address}}</el-form-item>
                                    <el-form-item v-if="item.type===3" style="margin-bottom: 0;" label="开始时间：">
                                        {{item.time}}
                                    </el-form-item>
                                    <el-form-item v-else style="margin-bottom: 0;" label="接机时间：">
                                        {{item.reception_time}}
                                    </el-form-item>
                                    <el-form-item v-if="item.type===3" style="margin-bottom: 0;" label="结束时间：">
                                        {{item.time_two}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item style="margin-bottom: 0;" label="人数：">{{item.people}}人</el-form-item>
                                    <el-form-item style="margin-bottom: 0;" label="行李：">{{item.bags}}件</el-form-item>
                                    <el-form-item style="margin-bottom: 0;" label="付款金额：">
                                        <span class="color-red">{{+item.price_all|parseMoney}}</span>
                                    </el-form-item>
                                    <el-form-item style="margin-bottom: 0;" label="留言备注：">{{item.remark}}</el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="order-btn">
                        <el-button size="mini" type="success">查看详情</el-button>
                        <el-button size="mini" type="primary">评价TA</el-button>
                    </div>
                </div>
            </div>
            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    export default {
        name: "driverOrder",
        data() {
            return {
                activeName: '0',
                list: []
            }
        },
        created() {
            this.driverTrackAll();
        },
        computed:{
            stateName(){
                if(this.activeName === '0'){
                    return '待确定'
                }else if(this.activeName === '3'){
                    return '待完成'
                }else if(this.activeName === '5'){
                    return '已完成'
                }
            }
        },
        methods: {
            handleClick() {
                this.driverTrackAll();
            },
            async driverTrackAll(){
                let [e, data] = await this.$api.driverTrackAllApi({order_state: this.activeName})
                this.list = data.result;
            }
        },
    }
</script>

<style scoped lang="less">
    .list-content{
        .order-item{
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            .order-item-head{
                width: 100%;
                height: 44px;
                background-color: #f5f5f5;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 0 20px;
                font-size: 14px;
                box-sizing: border-box;
            }
            .order-body{
                padding: 20px;
                box-sizing: border-box;
                background-color: #ffffff;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .order-body-img{
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                    border-radius: 6px;
                    margin-right: 20px;
                }
            }
            .order-content{
                flex: 1;
                height: 100%;
            }
            .order-btn{
                width: 200px;
                margin-top: auto;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>
